// -----------------------------------------------------------------------
// <copyright file="StyledText.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { IStyleableComponentProps } from '@fluentui/foundation-legacy/lib/IComponent';
import {
  classNamesFunction,
  IStyleFunctionOrObject,
  ITextProps,
  ITextStyles,
  ITextTokens,
  mergeStyles,
  styled,
  Text,
} from '@fluentui/react';
import * as React from 'react';

interface IStyledTextProps extends ITextProps {
  styles?: IStyleFunctionOrObject<IStyleableComponentProps<ITextProps, ITextTokens, ITextStyles>, ITextStyles>;
}

const getClassNames = classNamesFunction<IStyleableComponentProps<ITextProps, ITextTokens, ITextStyles>, ITextStyles>();

const Component = (props: IStyledTextProps): JSX.Element => {
  const classNames = getClassNames(props.styles!, {
    theme: props.theme!,
    className: props.className!,
  });
  return <Text {...props} className={mergeStyles(props.className, classNames.root)} />;
};

export const StyledText = styled(
  Component,
  (props: IStyleableComponentProps<ITextProps, ITextTokens, ITextStyles>): ITextStyles => ({
    root: {
      color: props.theme.semanticColors.bodyText,
    },
  })
);
